var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapAmountFrom = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5286 7.95143C13.7948 7.98809 14 8.21969 14 8.49993C14 8.80564 13.7558 9.05347 13.4545 9.05347H3.86671L7.3302 12.5542L7.38314 12.6162C7.54203 12.8326 7.52505 13.1401 7.3318 13.3371C7.11923 13.5537 6.77387 13.5544 6.56041 13.3387L2.1682 8.89973C2.14203 8.87429 2.11836 8.84623 2.09758 8.81597C1.94891 8.5998 1.96987 8.29995 2.16045 8.10737L6.56045 3.66129L6.62174 3.60782C6.83561 3.4475 7.1386 3.46603 7.33183 3.66297C7.54439 3.87961 7.54364 4.2301 7.33017 4.4458L3.86585 7.94638L13.4545 7.94638L13.5286 7.95143Z",
    fill: "#EE2222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapAmountFrom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-amount-from.54804cd6.svg";
export { ForwardRef as ReactComponent };